import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import AppLayout from '../../components/ui/AppLayout';
import SectionCard from '../../components/ui/SectionCard';
import PriceList from './PriceList';
import { EVENTO } from './torneioInfo';
import tokens from '../../theme/tokens';

const Hero = ({ onRegister }) => (
  <Box sx={{ color: '#fff', background: `linear-gradient(135deg, ${tokens.color.ink}, ${tokens.color.inkSoft})` }}>
    <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography variant="overline" sx={{ color: tokens.color.brandLight, fontWeight: 700 }}>Torneio Riviera FC</Typography>
          <Typography variant="h2" sx={{ fontSize: { xs: '2.6rem', md: '3.6rem' }, lineHeight: 1.05, my: 1.5 }}>Inscrições abertas</Typography>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ opacity: 0.85, mb: 3 }}>
            <CalendarMonthRoundedIcon />
            <Typography>{EVENTO.datas}</Typography>
          </Stack>
          <Button size="large" variant="contained" endIcon={<ArrowForwardRoundedIcon />} onClick={onRegister}>Quero me inscrever</Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box component="img" src="/image/capa_torneio.jpeg" alt="Torneio de Futebol" sx={{ width: '100%', borderRadius: 4, boxShadow: tokens.shadow.lg, display: 'block' }} />
        </Grid>
      </Grid>
    </Container>
  </Box>
);

const PresentationPage = () => {
  const navigate = useNavigate();
  const handleRegisterClick = () => navigate('/confirmarInscricao');

  return (
    <AppLayout hero={<Hero onRegister={handleRegisterClick} />}>
      <Typography variant="h5" sx={{ mb: 2 }}>Valores de inscrição</Typography>
      <PriceList />
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} md={6}>
          <SectionCard title="Formato e agenda" sx={{ height: '100%' }}>
            <Typography color="text.secondary" sx={{ mb: 2 }}>{EVENTO.formato}</Typography>
            <Stack spacing={1}>
              {EVENTO.agenda.map((item) => (
                <Stack key={item.quando} direction="row" spacing={2} sx={{ p: 1.5, borderRadius: 2, bgcolor: 'background.default' }}>
                  <Typography fontWeight={700} sx={{ minWidth: 120, color: tokens.color.brand }}>{item.quando}</Typography>
                  <Typography>{item.oque}</Typography>
                </Stack>
              ))}
            </Stack>
          </SectionCard>
        </Grid>
        <Grid item xs={12} md={6}>
          <SectionCard title="A festa" sx={{ height: '100%' }}>
            <Typography color="text.secondary">{EVENTO.festa}</Typography>
            <Button variant="contained" sx={{ mt: 3 }} onClick={handleRegisterClick}>Inscreva-se</Button>
          </SectionCard>
        </Grid>
      </Grid>
    </AppLayout>
  );
};

export default PresentationPage;
